import { B2BCartsApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const b2bCartsClient = new B2BCartsApi(ecomConfiguration)
